const React = require("react");

function MenuAlt4Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 8h16M4 16h16"
  }));
}

module.exports = MenuAlt4Icon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/MenuAlt4Icon.js
 ** module id = 564
 ** module chunks = 0
 **/